import { Component, Inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionState } from 'src/app/enums/action-state.enum';
import { SubscriptionRepo } from 'src/app/repositories/subscription-repo';
import { VehicleRepo } from 'src/app/repositories/vehicle-repo';
import { DataAfterCloseBadgesModal } from '../modal-badges/models/dataAfterCloseBadgesModal';
import { DataAfterCloseVehiclesModal } from './models/dataAfterCloseVehiclesModal';

@Component({
    selector: 'app-modal-vehicles',
    templateUrl: './modal-vehicles.component.html',
    styleUrls: ['./modal-vehicles.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalVehiclesComponent implements OnInit {

  // downloadFile
  backendResponseDownloadedFile: any = null;
  // uploadFile
  backendResponseUploadedFile: any = null;

  @Input()
  calledByOtherComponent = false;

  @Input()
  uid: string;

  constructor(
    private vehicleRepo: VehicleRepo,
    private subsRepo: SubscriptionRepo,
    @Inject(MAT_DIALOG_DATA) public data: DataAfterCloseBadgesModal) {
  }

  ngOnInit(): void {
    this.data = new DataAfterCloseVehiclesModal();
  }


  onUserWantsDownloadEvent(event: boolean): void {
    if (event) {
      this.downloadFile();
    }
  }

  onUserWantsUploadEvent(file: any): void {
    if (file) {
      this.uploadFile(file);
    }
  }



  downloadFile(): void {
    if (!this.calledByOtherComponent) {
      this.vehicleRepo.exportVehicleDefinition().toPromise().then((response) => {
        this.backendResponseDownloadedFile = response;
      }).catch((err) => {
        this.backendResponseDownloadedFile = err;
      });
      return;
    }

    this.subsRepo.exportVehicleDefinitionOfSubscribe(this.uid).toPromise().then((response) => {
      this.backendResponseDownloadedFile = response;
    }).catch((err) => {
      this.backendResponseDownloadedFile = err;
    });


  }

  uploadFile(file: any): void {
    this.data.uploadFileState = ActionState.LOADING;
    if (!this.calledByOtherComponent) {
      this.vehicleRepo.importVehicleDefinition(file).toPromise()
      .then((response) => {
        this.backendResponseUploadedFile = response;
        this.data.uploadFileState = ActionState.SUCCESS;
      })
      .catch((err) => {
        this.backendResponseUploadedFile = err;
        this.data.uploadFileState = ActionState.FAILED;
      });
      return;
    }

    this.subsRepo.importVehicleDefinitionOfSubscrition(file, this.uid).toPromise()
    .then((response) => {
      this.backendResponseUploadedFile = response;
      this.data.uploadFileState = ActionState.SUCCESS;
    })
    .catch((err) => {
      this.backendResponseUploadedFile = err;
      this.data.uploadFileState = ActionState.FAILED;
    });

  }


}
